/* assets/src/viewer/perf/stats.js
 * Contatori strumentati per l'acceptance: dimostrano che un cambio SOLO dimensionale
 * NON innesca un full rebuild (fullRebuilds resta invariato).
 */
export class Stats {
  constructor() {
    this.fullRebuilds = 0;
    this.dimensionalUpdates = 0;
    this.aspectUpdates = 0;
    this.effectsUpdates = 0;
  }

  inc(kind) {
    if (kind === 'topological') this.fullRebuilds++;
    else if (kind === 'dimensional') this.dimensionalUpdates++;
    else if (kind === 'aspect') this.aspectUpdates++;
    else if (kind === 'effects') this.effectsUpdates++;
  }

  snapshot() {
    return {
      fullRebuilds: this.fullRebuilds,
      dimensionalUpdates: this.dimensionalUpdates,
      aspectUpdates: this.aspectUpdates,
      effectsUpdates: this.effectsUpdates,
    };
  }
}
